module.exports = __webpack_public_path__ + "assets/img/ytj.afddb103.jpg";